import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { GitLabState } from "./state";

export const defaultState: GitLabState = {
  gitlab: {
    accessToken: "",
    authorEmail: "",
    authorName: "",
    branch: "",
    projectId: -1,
    lastLoad: new Date(0)
  }
};

export const gitLabModule = {
  state: defaultState,
  mutations,
  actions,
  getters
};
